module.exports = __webpack_public_path__ + "media/images/lb/826-10f9ed7dcd5c17652dc1dfb311b414fd.svg";